import { Star } from "lucide-react";

export const ScoreBadge = ({ score, recommendation, size = "sm" }) => {
  const high = score >= 4;
  const mid = score === 3;
  const bg = high ? "bg-[#2F6DA3] text-white border-[#2F6DA3]" : mid ? "bg-zinc-200 text-zinc-900 border-zinc-300" : "bg-white text-zinc-500 border-zinc-300";
  const px = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
  return (
    <span className={`inline-flex items-center gap-1 font-bold border ${bg} ${px}`} data-testid="score-badge">
      <Star size={size === "lg" ? 16 : 12} fill="currentColor" strokeWidth={0} />
      {score}/5{recommendation ? ` · ${recommendation}` : ""}
    </span>
  );
};

export const Stars = ({ score }) => (
  <span className="inline-flex" aria-label={`${score} out of 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={14}
        strokeWidth={2}
        className={i <= score ? "text-[#2F6DA3]" : "text-zinc-300"}
        fill={i <= score ? "#2F6DA3" : "none"}
      />
    ))}
  </span>
);
